import React, { FC } from "react";

import { Sort } from "@/components/atoms";
import { Table } from "@/components/molecules";
import { PackageSortProperty } from "@/shared/domain";

import PackageTableItem from "../PackagesTableItem/PackageTableItem";
import { packageTableColumns } from "./utils";

export type PackageTableProps = {
    packages: MyBrokerApi.DocumentsPackageToSign[];
    orderBy: Sort<PackageSortProperty>;
    handleSort: (orderBy: PackageSortProperty) => void;
};

const PackageTable: FC<PackageTableProps> = ({ packages, handleSort, orderBy }) => {
    return (
        <Table<MyBrokerApi.DocumentsPackageToSign, PackageSortProperty>
            columns={packageTableColumns}
            handleSort={handleSort}
            orderBy={orderBy}
            items={packages}
            renderItem={(packageToSign) => (
                <PackageTableItem key={`packages_page-item-${packageToSign.guid}`} pkg={packageToSign} />
            )}
        />
    );
};

export default PackageTable;
